import {ChecksMiniStatus, ChecksMiniStatusBoundary} from './mini-merge-sections/ChecksMiniStatus'
import {ApprovalsMiniStatus, ApprovalsMiniStatusBoundary} from './mini-merge-sections/ApprovalsMiniStatus'
import {CommentsMiniStatus, CommentsMiniStatusBoundary} from './mini-merge-sections/CommentsMiniStatus'
import styles from './mini-merge-sections/MiniMergeSections.module.css'
import {clsx} from 'clsx'
import {useState} from 'react'
import {usePullRequestState} from '../../../../hooks/use-pull-request-state'
import {PendingChecksBody} from './shared/PendingChecksBody'
import {useMergeabilityData} from './use-mergeability-data'

export function MiniOverviewMergeStatus() {
  const state = usePullRequestState()
  const [isChecksExpanded, setIsChecksExpanded] = useState(false)

  if (state === 'MERGED' || state === 'CLOSED') {
    return null
  }

  return (
    <div className={clsx(styles.MiniStatusGrid, isChecksExpanded && styles.MiniStatusGridExpanded)}>
      <section className={styles.MiniStatusWrapper} aria-label="Merge status">
        <ChecksMiniStatusBoundary>
          <ChecksMiniStatus expanded={isChecksExpanded} onToggle={() => setIsChecksExpanded(value => !value)} />
          {isChecksExpanded ? <ExpandedChecksSection /> : null}
        </ChecksMiniStatusBoundary>

        <CommentsMiniStatusBoundary>
          <CommentsMiniStatus />
        </CommentsMiniStatusBoundary>

        <ApprovalsMiniStatusBoundary>
          <ApprovalsMiniStatus />
        </ApprovalsMiniStatusBoundary>
      </section>
    </div>
  )
}

function ExpandedChecksSection() {
  const data = useMergeabilityData()
  if (!data) return null

  return (
    <section aria-label="Checks" className={styles.ExpandedChecks}>
      <PendingChecksBody
        data={data}
        emptyMessage="No checks have been reported for this pull request yet."
        emptyMessageVariant="neutral"
        itemName="mini-checks"
        transparentBackground
      />
    </section>
  )
}
